import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function HotArrivals({ items = [] }) {
  if (!items.length) {
    return (
      <div className="text-center py-16 font-semibold">
        Loading Hot Arrivals...
      </div>
    );
  }

  return (
    <div className="w-full px-4 py-10">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8">
        🔥 Hot Arrivals
      </motion.h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
        {items.map((item) => {
          const firstColor = item.colors?.[0];
          if (!firstColor) return null;

          return (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              whileHover={{ y: -4 }}
              transition={{ duration: 0.25 }}
              className="rounded-2xl shadow-md hover:shadow-xl bg-white transition-all p-2 sm:p-3">
              <Link to={`/product/${item.id}`} state={{ product: item }}>
                <div className="rounded-xl overflow-hidden w-full aspect-[4/5] bg-gray-100">
                  <motion.img
                    src={firstColor.images?.[0]}
                    alt={item.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="text-center mt-2 sm:mt-3">
                  <h3 className="text-xs sm:text-sm font-semibold line-clamp-1">
                    {item.title}
                  </h3>

                  <div className="flex justify-center items-baseline gap-2 whitespace-nowrap mt-1">
                    <span className="text-sm sm:text-base font-semibold text-[#1C1F1A] leading-none">
                      ₹{item.price}
                    </span>

                    {item.mrp && (
                      <span className="text-xs sm:text-sm text-red-600 line-through decoration-[1px] leading-none">
                        ₹{item.mrp}
                      </span>
                    )}

                    {item.mrp && (
                      <span className="text-xs sm:text-sm text-green-500 font-medium leading-none">
                        {Math.round(((item.mrp - item.price) / item.mrp) * 100)}
                        % OFF
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
